<!-- 记账历史 -->
<template>
   <div class='page_content'>
      <el-drawer :close-on-press-escape="true" :visible.sync="showStatus" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
         <advancePaymentRegAction v-if="showStatus" ref="advancePaymentRegAction" @drawerCancel="drawerCancel" @toDetail="toDetail" :actionData="actionData"></advancePaymentRegAction>
      </el-drawer>
      <subComponents ref="showSelectData"></subComponents>
      <div class="page_content_top">
         <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
         <div class="page_content_top_line">
            <vSearch @searchData="searchData" @openSearch="openSearch" :getRequestData=getRequestData v-if="pageShowData.jurHead" :searchList=pageShowData.jurHead.jurconfigform>
               <template slot="searchInput" slot-scope="{formOneValue}">
                  <el-select v-if="formOneValue.entityField == 'rgamPurchaser'" v-model="getRequestData[formOneValue.entityField]">
                     <el-option label="全部" value="">
                     </el-option>
                     <el-option v-for="(values,keys) in userOneList" :key="keys" :label="values.opmName" :value="values.opmId">
                     </el-option>
                  </el-select>
               </template>
            </vSearch>
         </div>
      </div>
      <div class="page_content_center">
         <el-table ref="elTable" v-if="pageShowData.jurTableVo" :show-summary="true" :summary-method="getSummaries" @sort-change="sortChange" size="mini" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row>
            <el-table-column label="选择操作" width="80">
               <template slot-scope="scope">
                  <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
                     <i class="el-icon-thumb"></i>
                  </el-radio>
               </template>
            </el-table-column>
            <template v-for="(tableValye,tableKey) in pageShowData.jurTableVo.jurconfigtable">
               <el-table-column align="center" v-if="tableValye.isShow==1" :key="tableKey" show-overflow-tooltip :min-width="tableValye.fieldWeight" :prop="tableValye.entityField" :label="tableValye.showField">
                  <template slot-scope="scope">
                     <span v-if="tableValye.fieldType == 'date'">
                        <span v-if="scope.row[tableValye.entityField]">
                           {{$common.getLocalTime(scope.row[tableValye.entityField])}}
                        </span>
                     </span>
                     <span v-else-if="tableValye.fieldType == 'dateTime'">
                        <span v-if="scope.row[tableValye.entityField]">
                           {{$common.getLocalTime(scope.row[tableValye.entityField], true)}}
                        </span>
                     </span>
                     <span v-else-if="tableValye.entityField == 'createTime'">
                        <span v-if="scope.row[tableValye.entityField]">
                           {{$common.getLocalTime(scope.row[tableValye.entityField])}}
                        </span>
                     </span>
                     <span v-else-if="tableValye.entityField == 'proofImg'">
                        <span v-if="scope.row[tableValye.entityField]">
                           <el-image style="width: 30px; height: 30px" :src="$store.getters.getConfig.imgUrl +
                    '/' +scope.row[tableValye.entityField]" :preview-src-list="[$store.getters.getConfig.imgUrl +
                    '/' +scope.row[tableValye.entityField]]">
                           </el-image>
                        </span>
                     </span>
                     <span v-else-if="tableValye.isRift == 1">
                        <a @click="toDetail(scope.row[tableValye.riftField])">{{scope.row[tableValye.entityField]}}</a>
                     </span>
                     <span v-else-if="tableValye.entityField == 'isOrder'">
                        <span>{{$common.getIsGsp(tableValye.formatterContent,scope.row[tableValye.entityField])}}</span>
                     </span>
                     <span v-else-if="tableValye.fieldType == 'formatter'">
                        <span v-for="item in JSON.parse(tableValye.formatterContent)">
                           <el-tag size="mini" v-if="item.key == scope.row[tableValye.entityField]">
                              {{ item.value }}
                           </el-tag>
                        </span>
                     </span>
                     <span v-else>
                        {{scope.row[tableValye.entityField]}}
                     </span>
                  </template>
               </el-table-column>
            </template>

         </el-table>
      </div>
      <div class="page_content_bottom">
         <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
      </div>
      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
         <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
      </el-dialog>
      <!-- 自定义设计 -->
      <customDesign ref="customDesign"></customDesign>
      <el-dialog title="凭证上传" :visible.sync="centerDialogVisible" width="50%" center>
         <el-upload :limit="1" :class="{hide:hideUploadBtn}" style="text-align: center;height: 210px;" :action="requesUrl + '/upload/fileupload'" list-type="picture-card" :headers='token' :on-remove="handleRemove"
                    :on-change="handleEditChange" :on-success="(res, field) => { handleAvatarSuccess(res, field) }">
            <img style="width: 200px;
            height: 200px;" v-if="imageUrl" :src="imageUrl" class="avatara">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
         </el-upload>
         <span slot="footer" class="dialog-footer">
            <el-button @click="centerDialogVisible = false,fileList=[]">取 消</el-button>
            <el-button type="primary" @click="sureSub">确 定</el-button>
         </span>
      </el-dialog>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import SearchScheme from "../../../byComponents/SearchScheme.vue";
import ExtractionScheme from "../../../byComponents/ExtractionScheme.vue";
import advancePaymentRegAction from "@/components/advancePaymentRegAction.vue";
export default {
   //import引入的组件需要注入到对象中才能使用
   components: {
      SearchScheme,
      ExtractionScheme,
      advancePaymentRegAction,
   },
   data() {
      //这里存放数据
      return {
         uploadUrl: "",
         token: {
            token: sessionStorage.getItem("token"),
         },
         imageUrl: "",
         hideUploadBtn: false,
         fileList: [],
         centerDialogVisible: false,
         tableHeight: 0,
         getRequestData: {
            rgamRapcus: "",
            rgamPurchaser: "",
            rgamRapcusName: "",
            page: 1,
            rows: 30,
            start:
               new Date(new Date().toLocaleDateString()).getTime() -
               31 * 24 * 3600 * 1000,
            end:
               new Date(new Date().toLocaleDateString()).getTime() +
               24 * 60 * 60 * 1000 -
               1,
            smId: "",
            smName: "",
            coName: "",
            coId: "",
         },
         returnData: {
            pages: 0, // 总页数
            total: 0, // 总条数
            pageNum: 0, // 当前页数
            list: [],
         },
         buttonList: [],
         userOneList: [],
         pageShowData: [],
         formDataList: [],
         selectedDataIndex: 0,
         exId: "",
         seId: "",
         ceshi: "",
         dialogTitle: "",
         seWidth: "",
         height: "",
         exTitle: "",
         seTitle: "",
         seWidth: "",
         exWidth: "",
         DialogVisible: false,
         DialogExtract: false,
         newFormDataList: [],
         seType: "",
         smId: "",
         showStatus: false,
         actionData: {},
         parentSearchData: {},
         requesUrl: "",
         ormId: "",
      };
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
      "getRequestData.rgamRapcusName": {
         handler: function (newValue, oldValue) {
            if (newValue == "") {
               this.getRequestData.rgamRapcus = "";
            }
         },
         deep: true,
      },
      "getRequestData.coName": {
         handler: function (newValue, oldValue) {
            if (newValue == "") {
               this.getRequestData.coId = "";
            }
         },
         deep: true,
      },
      "getRequestData.smName": {
         handler: function (newValue, oldValue) {
            if (newValue == "") {
               this.getRequestData.smId = "";
            }
         },
         deep: true,
      },
   },
   //方法集合
   methods: {
      handleRemove(file, fileList) {
         this.hideUploadBtn = fileList.length >= 1;
      },
      handleEditChange(file, fileList) {
         this.hideUploadBtn = fileList.length >= 1;
      },
      handleAvatarSuccess(res, file, e) {
         console.log(res, file);
         if (res.status == 200) {
            this.fileList = [
               {
                  fileUrl: res.result[0].fileUrl,
                  url:
                     this.$store.getters.getConfig.imgUrl +
                     "/" +
                     res.result[0].fileUrl,
               },
            ];
            this.imageUrl =
               this.$store.getters.getConfig.imgUrl +
               "/" +
               res.result[0].fileUrl;
         }
      },
      changeTime(val) {
         if (val) {
            var time = val + 24 * 60 * 60 * 1000 - 1;
            this.getRequestData.end = time;
         }
      },
      sureSub() {
         this.$http
            .registerUploadImg({
               ids: [this.returnData.list[this.selectedDataIndex].businessId],
               proofImg: this.fileList[0].fileUrl,
            })
            .then((res) => {
               if (res.status == 200) {
                  this.$message.success(res.message);
                  this.centerDialogVisible = false;
                  this.fileList = [];
                  this.searchData();
               }
            });
      },
      // 子组件触发
      drawerCancel() {
         this.showStatus = false;
         this.getDataList();
      },
      // 点击穿透字段 传参单号
      toDetail(orderId) {
         console.log(orderId);
         if (orderId) {
            // 设置为true 打开穿透组件首页
            var isPenetrate = true;
            // 设置缓存 存入点击单号
            this.resetSetItem("penetrateOrderId", orderId);
            // 与父级跨域通信 传递isPenetrate参数
            window.parent.postMessage(
               {
                  //向窗口发送MessageEvent消息
                  cmd: "returnFormJson",
                  params: {
                     isPenetrate,
                  }, //参数
               },
               "*"
            );
         }
      },
      changeInputModel(val) {
         if (val != "" || val != undefined) {
            this.DialogVisible = false;
            this.paramValue(val);
         }
      },
      getSeWidth(e) {
         console.log(e);
         this.seWidth = e + "%";
      },
      getWidth(e) {
         console.log(e);
         this.exWidth = e + "%";
      },
      getSearchName(e) {
         console.log(e);
         this.seTitle = e;
      },
      getExtractName(e) {
         console.log(e);
         this.exTitle = e;
      },
      // 检索Id, 索引(表格中), 标识
      openSearch({ sId, index, type, sField }) {
         this.seId = sId;
         this.sField = sField;
         this.DialogVisible = true;
         this.parentSearchData[type] = this.getRequestData[type];
      },
      // 赋值字段
      paramValue(val) {
         let arr = this.sField.split(",");
         arr.forEach((item) => {
            this.getRequestData[item] = val[item];
         });
      },
      isShowData(name, value) {
         console.log(name);
         switch (name) {
            case "rgamRapcus":
               var dataInfo = sessionStorage.getItem("selectSupplierData");
               if (dataInfo) {
                  dataInfo = JSON.parse(dataInfo);
                  this.getRequestData.rgamRapcus = dataInfo.smId;
                  this.getRequestData.rgamRapcusName = dataInfo.smName;
               }
               break;
            default:
               this.getRequestData[name] = value;
         }
      },

      // 获取数据列表
      async getPageInfo() {
         var pathId = parent.getMenuInfo(this.$route.path);
         let responseData = await this.$http.getJur({
            ids: [pathId.jurId],
         });
         console.log(responseData);
         if (responseData.status == 200) {
            this.getButtonList();
            this.pageShowData = responseData.result;
            this.formDataList = this.pageShowData.jurFormVoList;
            var obj = {};
            if (this.pageShowData.jurHead) {
               obj = this.$common.getSearchData(
                  this.pageShowData.jurHead.jurconfigform,
                  "page",
                  "rows",
                  30
               );
            } else {
               obj = this.$common.getSearch(
                  this.getRequestData,
                  "start",
                  "end",
                  "page",
                  "rows",
                  30
               );
            }
            for (const key in obj) {
               this.$set(this.getRequestData, key, obj[key]);
            }
            this.getDataList();
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      clear(val) {
         if (val) {
            var arr = val.split(",");
            arr.forEach((item) => {
               this.$set(this.getRequestData, item, "");
            });
         }
      },
      // 动作集合
      actionSet(actionData) {
         console.log(actionData.actionType);
         switch (actionData.actionType) {
            case 0:
               this.showStatus = true;
               this.actionData = {
                  cate: 0,
                  formData: this.formDataList,
                  oldData: "",
                  orderId: "",
                  printSouce: "",
                  printJurId: "",
               };
               break;
            case 1:
               if (this.returnData.list.length <= 0) {
                  if (!dataInfo) {
                     this.$message({
                        message: "暂无数据",
                        type: "error",
                     });
                     return false;
                  }
               }
               if (!this.returnData.list[this.selectedDataIndex]) {
                  this.$message({
                     message: "请先选择您要操作的数据",
                     type: "error",
                  });
                  return false;
               }
               var dataInfo = this.returnData.list[this.selectedDataIndex];
               this.showStatus = true;
               this.actionData = {
                  cate: 1,
                  formData: this.formDataList,
                  oldData: dataInfo,
                  orderId: dataInfo.rgamId,
                  printSouce: "",
                  printJurId: "",
               };
               break;
            case 2:
               this.delDataAction();
               break;
            case 3:
               this.submitData();
               break;
            case 4:
               this.exportData();
               break;
            case 10:
               this.hongChong();
               break;
            case 11:
               if (this.returnData.list.length <= 0) {
                  if (!dataInfo) {
                     this.$message({
                        message: "暂无数据",
                        type: "error",
                     });
                     return false;
                  }
               }
               if (!this.returnData.list[this.selectedDataIndex]) {
                  this.$message({
                     message: "请先选择您要操作的数据",
                     type: "error",
                  });
                  return false;
               }
               this.imageUrl = "";
               this.fileList = []
               if (this.returnData.list[this.selectedDataIndex].proofImg) {
                  this.fileList = [
                     {
                        url:
                           this.$store.getters.getConfig.imgUrl +
                           "/" +
                           this.returnData.list[this.selectedDataIndex]
                              .proofImg,
                     },
                  ];
                  this.imageUrl =
                     this.$store.getters.getConfig.imgUrl +
                     "/" +
                     this.returnData.list[this.selectedDataIndex].proofImg;
               }
               this.centerDialogVisible = true;
               break;
            case 12:
               this.exportDataLit();//导出预付款登记列
               break;
            case 8:
               this.Settlement();//导出预付款登记列
               break;
         }
      },
      Settlement() {
         if (this.returnData.list.length <= 0) {
            if (!dataInfo) {
               this.$message({
                  message: "暂无数据",
                  type: "error",
               });
               return false;
            }
         }
         if (!this.returnData.list[this.selectedDataIndex]) {
            this.$message({
               message: "请先选择您要操作的数据",
               type: "error",
            });
            return false;
         }
         this.$confirm("是否完成结算?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            
            type: "warning",
         })
            .then(async () => {
               const responseData = await this.$http.registerIgnoreSeele({ ids: [this.returnData.list[this.selectedDataIndex].businessId] });
               if (responseData.status == 200) {
                  this.$message({
                     type: "success",
                     message: "操作成功",
                  });

                  this.getDataList();
               } else {
                  this.$message({
                     message: responseData.message,
                     type: "error",
                  });
               }
            })
      },
      exportDataLit() {
         let sendData = JSON.parse(JSON.stringify(this.getRequestData))
         sendData.ormId = this.ormId
         window.location.href =
            this.requesUrl + `/register/exportPrmv${this.$common.getUrl(sendData)}`
      },
      //  导出
      exportData() {
         window.location.href =
            this.requesUrl +
            "/register/exportAccountData?ormId=" +
            String(this.ormId) +
            "&smId=" +
            this.getRequestData.smId +
            "&start=" +
            this.getRequestData.start +
            "&end=" +
            this.getRequestData.end +
            "&coId=" +
            this.getRequestData.coId;
      },
      // 红冲
      hongChong() {
         if (this.returnData.list.length <= 0) {
            if (!dataInfo) {
               this.$message({
                  message: "暂无数据",
                  type: "error",
               });
               return false;
            }
         }
         if (!this.returnData.list[this.selectedDataIndex]) {
            this.$message({
               message: "请先选择您要操作的数据",
               type: "error",
            });
            return false;
         }
         var dataInfo = this.returnData.list[this.selectedDataIndex];
         this.$confirm("确定红冲吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
         })
            .then(async () => {
               var data = {
                  ids: [dataInfo.businessId],
               };
               let responseData = await this.$http.rushRedRegister(data);
               if (responseData.status == 200) {
                  this.$message({
                     message: responseData.message,
                     type: "success",
                  });
                  this.getDataList();
               } else {
                  this.$message({
                     message: responseData.message,
                     type: "error",
                  });
               }
            })
            .catch(() => { });
      },
      openFormDesign() {
         let pathInfo = parent.getMenuInfo(this.$route.path);
         this.$refs["customDesign"].openBox(
            pathInfo.jurId,
            this.pageShowData,
            pathInfo.jurName
         );
      },
      // 获取供货员
      async getSpecialUser() {
         let responseData = await this.$http.getSpecialUser({
            opmBuyer: 1,
         });
         if (responseData.status == 200) {
            this.userOneList = responseData.result;
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      // 处理表格排序事件
      sortChange(column) {
         this.returnData.list = this.$common.sortChange(column, this.returnData.list, this.pageShowData.jurTableVo.jurconfigtable, 'entityField')
      },
      getSummaries(param) {
         const { columns, data } = param;
         const sums = [];
         columns.forEach((column, index) => {
               if (index === 0) {
                  sums[index] = '合计';
                  return;
               }
               if (column.property == 'totalMoney' || column.property == 'preMoney' || column.property == 'payMoney') {
                  const values = data.map(item => Number(item[column.property]));
                  if (!values.every(value => isNaN(value))) {
                     sums[index] = values.reduce((prev, curr) => {
                           const value = Number(curr);
                           if (!isNaN(value)) {
                              return this.$common.getDecimalInfo(3, NP.plus(prev, curr));
                           } else {
                              return prev;
                           }
                     }, 0);
                  } else {
                     sums[index] = '';
                  }
               } else {
                  sums[index] = '';
               }
         });

         return sums;
      },
      // 数据搜索
      searchData() {
         this.getRequestData.page = 1;
         this.getDataList();
      },
      // 数据翻页
      setDataPageNumber(val) {
         this.getRequestData.page = val;
         this.getDataList();
      },
      // 切换显示条数
      setDataPageSize(val) {
         this.getRequestData.page = 1;
         this.getRequestData.rows = val;
         this.getDataList();
      },
      // 获取数据列表
      async getDataList() {
         if (this.getRequestData.smName == "") {
            this.getRequestData.smId = "";
         }
         let responseData = await this.$http.queryRegisterList(
            this.getRequestData
         );
         console.log(responseData);
         if (responseData.status == 200) {
            this.returnData.list = responseData.result.list;
            this.returnData.pages = responseData.result.pages;
            this.returnData.total = responseData.result.total;
            this.returnData.pageNum = responseData.result.pageNum;
            this.selectedDataIndex = 0;
            this.$nextTick(() => {
               this.$refs.elTable.doLayout();
            });
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      // 提交审核
      submitData() {
         if (this.returnData.list.length <= 0) {
            if (!dataInfo) {
               this.$message({
                  message: "暂无数据",
                  type: "error",
               });
               return false;
            }
         }
         if (!this.returnData.list[this.selectedDataIndex]) {
            this.$message({
               message: "请先选择您要操作的数据",
               type: "error",
            });
            return false;
         }
         var dataInfo = this.returnData.list[this.selectedDataIndex];
         this.$confirm("确定要提交审核吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
         })
            .then(async () => {
               var delData = {
                  ids: [dataInfo.rgamId],
               };
               let responseData = await this.$http.submitPurchaseReturn(
                  delData
               );
               if (responseData.status == 200) {
                  this.$message({
                     type: "success",
                     message: "操作成功!",
                  });

                  this.getDataList();
               } else {
                  this.$message({
                     message: responseData.message,
                     type: "error",
                  });
               }
            })
            .catch(() => { });
      },
      // 删除数据
      delDataAction() {
         if (this.returnData.list.length <= 0) {
            if (!dataInfo) {
               this.$message({
                  message: "暂无数据",
                  type: "error",
               });
               return false;
            }
         }
         if (!this.returnData.list[this.selectedDataIndex]) {
            this.$message({
               message: "请先选择您要操作的数据",
               type: "error",
            });
            return false;
         }
         var dataInfo = this.returnData.list[this.selectedDataIndex];
         this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
         })
            .then(async () => {
               var delData = {
                  ids: [dataInfo.rgamId],
               };
               let responseData = await this.$http.delPurchaseReturn(delData);
               if (responseData.status == 200) {
                  this.$message({
                     type: "success",
                     message: "删除成功!",
                  });

                  this.getDataList();
               } else {
                  this.$message({
                     message: responseData.message,
                     type: "error",
                  });
               }
            })
            .catch(() => {
               this.$message({
                  type: "info",
                  message: "已取消删除",
               });
            });
      },
      // 获取按钮权限
      async getButtonList() {
         this.buttonList = await this.$common.getActionButton();
         
      },
//获取状态
      getIsGsp(str, val) {
         try {
            if (str.indexOf("[") === -1) return val;
            str && str.replace(/\\/g, "");
            let arr = JSON.parse(str);
            let len = arr.length;
            let newStr = "";
            for (let i = 0; i < len; i++) {
               if (arr[i].key == val) {
                  newStr = arr[i].value;
                  break;
               }
            }
            return newStr ? newStr : val;
         } catch (ex) {
            return val;
         }
      },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.requesUrl = this.$store.getters.getConfig.requestUrl;
      this.ormId = sessionStorage.getItem("ormId");
      this.getPageInfo();
      this.getSpecialUser();
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() { },
   beforeCreate() { }, //生命周期 - 创建之前
   beforeMount() { }, //生命周期 - 挂载之前
   beforeUpdate() { }, //生命周期 - 更新之前
   updated() {
      this.tableHeight = this.$common.getTableHeight();
   }, //生命周期 - 更新之后
   beforeDestroy() { }, //生命周期 - 销毁之前
   destroyed() { }, //生命周期 - 销毁完成
   activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_content_tag {
   margin-right: 1rem;
}

.el-tabs--border-card_new {
   height: 85vh;
   overflow-y: scroll;
}
::v-deep .hide .el-upload--picture-card {
   display: none !important;
}
</style>